import { useEffect, useState } from 'react';
import { PropTypes } from 'prop-types';
import usePrevious from '@hooks/usePrevious';
import useSavedContacts from '@hooks/useSavedContacts';

const useIsContactFavorite = graphID => {
    const [isFavorite, setIsFavorite] = useState();
    const { data: contactsData } = useSavedContacts({ fields: 'id recordId' });

    const prevSavedContacts = usePrevious(contactsData?.contacts);

    useEffect(() => {
        if (
            !graphID ||
            !contactsData?.contacts ||
            (prevSavedContacts && contactsData.contacts.length === prevSavedContacts.length)
        ) {
            return;
        }

        const ids = contactsData.contacts.map(c => c.id);
        setIsFavorite(ids.includes(graphID));
    }, [graphID, contactsData, prevSavedContacts]);

    return isFavorite;
};

useIsContactFavorite.propTypes = {
    graphID: PropTypes.string,
};

export default useIsContactFavorite;
